export default __webpack_public_path__ + "static/media/PAFI_Ringkasan Risalah RUPS_30 Juni 2025.9d41a28c.pdf";